import { Answer, Scenario } from '../../state/interfaces'
import { cloneDeepWith, isString } from 'lodash'
import { initTranslation } from '../../i18n'
import { i18n } from 'i18next'
import { Parser } from './interfaces'
import { getLocale } from '../../i18n/locale'

const translator = initTranslation(getLocale())

export const i18nParser: Parser = ({ scenario }) => Promise.resolve(parser(translator)(scenario))

const parser =
  (translator: i18n) =>
  (scenario: Scenario): Scenario => {
    const translatedObj = cloneDeepWith(scenario.steps, (kV: Answer['text']) => {
      if (isString(kV)) {
        return translator.t(kV)
      } else if (kV.key) {
        return translator.t(kV.key, kV.options)
      }
    })

    return {
      ...scenario,
      steps: [...translatedObj],
    }
  }
